import { Fragment } from 'react';
import { ClientName, ProjectName } from '../crm/common';
import type { AssignmentScope, useScopeNames } from './scope';

/**
 * A role assignment's scope as people read it (FRD-USR-007): the department, cost centre and
 * location named from the masters, and the project and client named and linked to their pages only
 * for a session that may view them. No scope reads "Whole organization".
 */
export function ScopeText({
  scope,
  names,
}: {
  scope: AssignmentScope;
  names: ReturnType<typeof useScopeNames>;
}) {
  const parts = names.organizationParts(scope);
  if (parts.length === 0 && scope.projectId === null && scope.clientId === null) {
    return <>Whole organization</>;
  }
  return (
    <>
      {parts.map((part, index) => (
        <Fragment key={part}>
          {index > 0 && ' · '}
          {part}
        </Fragment>
      ))}
      {scope.projectId !== null && (
        <>
          {parts.length > 0 && ' · '}
          Project <ProjectName id={scope.projectId} />
        </>
      )}
      {scope.clientId !== null && (
        <>
          {parts.length > 0 || scope.projectId !== null ? ' · ' : ''}
          Client <ClientName id={scope.clientId} />
        </>
      )}
    </>
  );
}
